function buildFormData( { form, page, themeData } ) {
  const data = new FormData();

  data.append( "action", "arb_load_properties" );
  data.append( "page", String( page ) );

  // Контекст сторінки (property_type)
  if ( themeData && themeData.propertyType ) {
    data.append( "property_type", themeData.propertyType );
  }

  // Збираємо всі поля з форми
  if ( form ) {
    const fields = form.querySelectorAll( "select[name], input[name]" );

    fields.forEach( (el) => {
      const name = el.getAttribute( "name" );
      if ( !name ) return;

      if ( el.tagName === "INPUT" && (el.type === "submit" || el.type === "button") ) {
        return;
      }

      const value = String( el.value ?? "" ).trim();

      if ( value !== "" ) {
        data.append( name, value );
      }
    } );
  }

  return data;
}

function scrollToObjectsTop() {
  const section = document.getElementById( "objects-section" );
  if ( !section ) return;

  const y = section.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo( {
    top: y - 80,
    behavior: "smooth",
  } );
}



/**
 * Номер сторінки з поточної адреси: /catalog/apartments/page/3/ → 3
 */
function pageFromLocation() {
  const match = window.location.pathname.match( /\/page\/(\d+)\/?$/ );
  return match ? parseInt( match[1], 10 ) : 1;
}

export function objectsFilterHandler() {
  const paginationNav = document.getElementById( "pagination-list" );
  const resultsWrapper = document.getElementById( "objects-results" );
  const form = document.querySelector( ".filter-form" );

  if ( !paginationNav || !resultsWrapper ) {
    return;
  }

  const supportsHistory = typeof window.history !== "undefined"
    && typeof window.history.pushState === "function";

  // Щоб перше натискання «Назад» повернуло на сторінку, а не з сайту.
  if ( supportsHistory ) {
    window.history.replaceState(
      { arbPage: pageFromLocation() },
      "",
      window.location.href
    );
  }

  function loadPage( page, options ) {
    const opts = options || {};

    if ( paginationNav.classList.contains( "loading" ) ) {
      return;
    }
    
    paginationNav.classList.add( "loading" );
     resultsWrapper.classList.add("loading");

    const data = buildFormData( { form, page, themeData } );

    fetch( themeData.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      body: data,
    } )
      .then( (response) => response.json() )
      .then( (res) => {
        if ( res.success ) {
          resultsWrapper.innerHTML = res.data.objectsHtml;
          paginationNav.innerHTML = res.data.paginationHtml;
          const newObjectsList = resultsWrapper.querySelector( ".objects-list" );
          if ( newObjectsList ) {
            newObjectsList.dataset.currentPage = String( res.data.currentPage );
          }

          updateHistory( res.data, page, opts );
          scrollToObjectsTop();
        }
      } )
      .catch( (err) => {
        console.error( "AJAX pagination/filter error:", err );
      } )
      .finally( () => {
        paginationNav.classList.remove( "loading" );
        resultsWrapper.classList.remove("loading");
      } );
  }

  /**
   * Адреса відображає тип, район і номер сторінки — усе, що сервер уміє
   * відтворити сам. Значення фільтрів в адресу не потрапляють, тому
   * застосування фільтра скидає номер сторінки: інакше адреса обіцяла б
   * те, чого при перезавантаженні не буде.
   */
  function updateHistory( payload, page, opts ) {
    if ( !supportsHistory || opts.skipHistory ) {
      return;
    }

    // Застосували фільтр → повертаємось на базову адресу без /page/N/.
    if ( opts.resetToBase ) {
      if ( payload.baseUrl ) {
        window.history.replaceState( { arbPage: 1 }, "", payload.baseUrl );
      }
      return;
    }

    if ( opts.url ) {
      window.history.pushState( { arbPage: page }, "", opts.url );
    }
  }

  // Пагінація
  paginationNav.addEventListener( "click", (e) => {
    const target = e.target.closest( "[data-page], .page-numbers" );
    if ( !target ) return;

    e.preventDefault();

    let page = target.dataset.page;

    if ( !page && target.classList.contains( "page-numbers" ) ) {
      page = target.getAttribute( "data-page" ) || "1";
    }

    page = parseInt( page, 10 );
    if ( Number.isNaN( page ) || page < 1 ) return;

    // Справжній href є тільки тоді, коли сервер може віддати цю сторінку сам.
    const href = target.getAttribute( "href" );

    loadPage( page, { url: href && href !== "#" ? href : null } );
  } );

  // Submit форми → AJAX пошук
  if ( form ) {
    form.addEventListener( "submit", (e) => {
      e.preventDefault();
      loadPage( 1, { resetToBase: true } );
    } );
  }

  // Кнопки «Назад» і «Вперед» у браузері
  window.addEventListener( "popstate", () => {
    loadPage( pageFromLocation(), { skipHistory: true } );
  } );
}

